import { render, staticRenderFns } from "./FamilyMember.vue?vue&type=template&id=49acc3b9&"
import script from "./FamilyMember.vue?vue&type=script&lang=js&"
export * from "./FamilyMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports